import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import { Collapse } from '@isyc-react/design/bootstrap';
import React from 'react';
export const EnrollmentCourseStructureSubtrainingProgramComponent = props => {
  const {
    CourseCard,
    subtrainingProgram,
    allsubtrainingPrograms,
    level
  } = props;
  const [open, setIsOpen] = React.useState(true);
  const onClickHeader = () => {
    setIsOpen(state => !state);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `px-sm-4 mb-4 level-${level}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    onClick: onClickHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: "course-list cursor-pointer rounded-5 px-4 p-3 d-flex",
    "aria-expanded": open
  }, /*#__PURE__*/React.createElement("div", {
    className: "arrow"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "mb-0"
  }, subtrainingProgram.name))), /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row courses"
  }, subtrainingProgram.enrollmentCourses.map((x, i) => /*#__PURE__*/React.createElement(CourseCard, {
    key: i,
    enrollmentCourse: x
  }))), allsubtrainingPrograms.filter(x => x.parentId === subtrainingProgram.id).sort((a, b) => a.order - b.order).map((x, i) => /*#__PURE__*/React.createElement(EnrollmentCourseStructureSubtrainingProgramComponent, {
    key: i,
    CourseCard: CourseCard,
    subtrainingProgram: x,
    allsubtrainingPrograms: allsubtrainingPrograms,
    level: level + 1
  }))))));
};